import React from "react";
import { Link } from "@quintype/components";
import { object, bool, array, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import MenuItems from "../../molecules/menu-items";
import { getSectionSlug } from "../../utils";

import "./story-meta-info.m.css";

const StoryMetaInfo = ({ story, iconLiveBlog, sections, showPublishedAt = true, menuItems = [], onClick }) => {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "Asia/Calcutta",
    hour: "numeric",
    minute: "numeric"
  };
  const publishedAt = new Date(story["published-at"]).toLocaleString("en-US", options);
  const storySection = story.sections[0]["display-name"] || story.sections[0]["name"];
  const authorDetails = (story.authors && story.authors[0]["name"]) || story["author-name"];
  const getAuthorId = get(story, ["authors", 0, "id"], story["author-id"]);
  const section = story.sections && get(story, ["sections", "0"], "");
  const sectionLabel = get(story, ["metadata", "story-attributes", "sectionlabel", 0]);
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const slug = getSectionSlug(section, sections);
  return (
    <div styleName="wrapper">
      {!sectionLabel && (
        <Link href={slug} styleName="section-name">
          <Headline text={storySection} headerType={13} headerLevel={3} />
        </Link>
      )}
      {showPublishedAt && (
        <div styleName="date-time">
          <span>Updated on </span>
          <time dateTime={new Date(story["published-at"]).toISOString()}>: {publishedAt} IST </time>
        </div>
      )}
      {sectionLabel && (
        <div styleName="section-name">
          <Headline text={sectionLabel} headerType={13} headerLevel={3} />
        </div>
      )}

      {menuItems.length ? <MenuItems menuItems={menuItems} onClick={onClick} /> : null}
      <div styleName="headline">
        {iconLiveBlog && !isClosed && <span styleName={"live-text"}>LIVE</span>}
        <Headline text={story.headline || ""} headerType={11} headerLevel={1} />
      </div>
      {showPublishedAt && (
        <div styleName="published-info">
          <p styleName="author-byline">
            <span>By </span>
            <Link href={`/author/${getAuthorId}`}>{authorDetails}</Link>
          </p>
        </div>
      )}
      {story.subheadline && (
        <div styleName="sub-headline">
          {" "}
          <Headline text={story.subheadline} headerType={13} headerLevel={4} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

StoryMetaInfo.propTypes = {
  story: object,
  iconLiveBlog: bool,
  showPublishedAt: bool,
  menuItems: array,
  onClick: func,
  sections: array
};

export default connect(
  mapStateToProps,
  null
)(StoryMetaInfo);
